export interface PaletteColor {
  key: string;
  hex: string;
}

export const CHIP_PALETTE: PaletteColor[] = [
  { key: "CHIP_COLOR_WHITE", hex: "#f5f5f5" },
  { key: "CHIP_COLOR_RED", hex: "#c0392b" },
  { key: "CHIP_COLOR_GREEN", hex: "#27ae60" },
  { key: "CHIP_COLOR_BLACK", hex: "#1c1c1c" },
  { key: "CHIP_COLOR_PURPLE", hex: "#7d3c98" },
  { key: "CHIP_COLOR_YELLOW", hex: "#f1c40f" },
  { key: "CHIP_COLOR_BLUE", hex: "#2471a3" },
  { key: "CHIP_COLOR_ORANGE", hex: "#e67e22" },
  { key: "CHIP_COLOR_PINK", hex: "#e91e8c" },
  { key: "CHIP_COLOR_GREY", hex: "#7f8c8d" },
];

export interface ChipDesign {
  id: string;
}

export const CHIP_DESIGNS: ChipDesign[] = [
  { id: "classic" },
  { id: "striped" },
  { id: "blades" },
  { id: "dice" },
  { id: "ornate" },
];

export const DEFAULT_CHIP_DESIGN_ID = CHIP_DESIGNS[0].id;
